export default __webpack_public_path__ + "static/media/loading-white.19a8d107.gif";